module.exports = __webpack_public_path__ + "static/media/phil-leader-list.673e5a17.jpg";